import { globalNotifyError, globalNotifySuccess } from './AlertToast';
import $ from 'jquery';

export const handleCapture = (onSuccess) => {
    const xml = `<?xml version="1.0"?>
    <PidOptions ver="1.0">
      <Opts fCount="1" fType="2" iCount="0" pCount="0" pType="0" pgCount="2" format="0" iType="0" pidVer="2.0" timeout="10000" pTimeout="20000" wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=" posh="UNKNOWN" env="P" />
      <CustOpts>
        <Param name="mantrakey" value="" />
      </CustOpts>
    </PidOptions>`;

    function getErrorDetails(xmlString) {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlString, 'text/xml');

        const parseError = xmlDoc.getElementsByTagName('parsererror');
        if (parseError.length > 0) {
            return { errCode: '999', errInfo: 'Invalid XML response from device.' };
        }

        const respElement = xmlDoc.querySelector('Resp');
        if (!respElement) {
            return { errCode: '998', errInfo: 'No <Resp> tag found in device response.' };
        }

        return {
            errCode: respElement.getAttribute('errCode') || '997',
            errInfo: respElement.getAttribute('errInfo') || 'Unknown error'
        };
    }

    $.ajax({
        type: 'CAPTURE',
        async: true,
        crossDomain: true,
        url: 'https://127.0.0.1:11100/rd/capture',
        data: xml,
        contentType: 'text/xml; charset=utf-8',
        processData: false,
        success: function (data) {
            $('div.spanner').addClass('show');
            $('#txtPidData').val(data);

            const { errCode, errInfo } = getErrorDetails(data);

            if (errInfo === 'Success.') {
                globalNotifySuccess('Finger Capture Success');
                onSuccess && onSuccess(data);
            } else {
                globalNotifyError(`Error ${errCode}: ${errInfo}`);
                onSuccess && onSuccess(null);
            }

            $('div.spanner').removeClass('show');
        },
        error: function (jqXHR) {
            $('div.spanner').removeClass('show');
            globalNotifyError('Please Connect Your Biometric Device');
            console.log('Error:', jqXHR);
        }
    });
};
